import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "aw-dynamics365-form" }
const _hoisted_2 = { class: "aw-form" }
const _hoisted_3 = { ref: "formRoot" }
const _hoisted_4 = { ref: "root" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmbedCode = _resolveComponent("EmbedCode")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.embed_code_cleaned)
          ? (_openBlock(), _createBlock(_component_EmbedCode, {
              key: 0,
              html: _ctx.embed_code_cleaned,
              onScriptLoaded: _ctx.renderForm
            }, null, 8, ["html", "onScriptLoaded"]))
          : _createCommentVNode("", true)
      ], 512),
      _createVNode("div", _hoisted_4, null, 512)
    ])
  ]))
}